import React from 'react';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import { addMinutes } from 'date-fns';

import DateRangePickerField from 'common/forms/DateRangePickerField';
import { filterEvents } from 'store/thunks/eventThunks';

const EventsOuterFilter = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ criticalEvents: { events } }) => events.filter);

  const onHandleDateChange = (createdAt) => {
    dispatch(
      filterEvents({
        filter: {
          ...filter,
          createdAt,
        },
      })
    );
  };

  return (
    <Grid item>
      <DateRangePickerField
        label='Date Range'
        onDateChange={onHandleDateChange}
        initialValue={filter?.createdAt}
        maxDate={addMinutes(new Date(), 60)}
      />
    </Grid>
  );
};

export default EventsOuterFilter;
